import React from "react";
import Accordion from "../components/Accordion";

export default function About() {
    const accordionItems = [
        {
            title: "What does car leasing mean?",
            content:
                "Leasing a car is essentially a long-term rental. An initial payment is made, followed by fixed monthly payments throughout your contract."
        },
        {
            title: "How do I lease a car?",
            content:
                "Choose from our range of lease deals and contract lengths (usually 2–4 years), then apply. Once approved, you’ll receive your new vehicle."
        },
        {
            title: "Do I need to buy insurance when leasing?",
            content:
                "Yes, you’ll need your own insurance. We can advise on the type of cover you’ll need."
        },
        {
            title: "What happens at the end of the lease?",
            content:
                "You return the car. If it’s in good condition and within agreed mileage, you won’t pay extra. You may then choose a new deal."
        }
    ];

    return (
        <main className="max-w-4xl mx-auto px-4 py-8">
            <h2 className="text-2xl font-bold mb-4">About Us</h2>
            <p className="mb-6 text-slate-700">
                We pride ourselves on offering a caring, personal service. Whether you're looking for
                something specific or just a general feel for your budget, check out our latest deals or get in touch.
            </p>
            <h3 id="how-leasing-works" className="text-xl font-semibold mb-3">
                How Leasing Works
            </h3>
            <Accordion items={accordionItems} />
        </main>
    );
}
